import React from 'react';
import logo from "../../assests/img/image-logo.png"
import clear_correct from "../../assests/img/clear-correct.png"
import dva from "../../assests/img/dva1.jpg"
import hicaps from "../../assests/img/hicaps.png"
import medicare from "../../assests/img/medicare.png"
import nsw from "../../assests/img/nsw.png"
import smileLogo from "../../assests/img/smileLogo.png"

const ImageSlider = () => {

    const images = [
        {  width: '27rem', height: '14rem', src:smileLogo , link: 'https://www.smile.com.au/'},
        {  width: '27rem', height: '14rem', src:medicare},
        { width: '27rem', height: '14rem', src:nsw},
        {  width: '27rem', height: '14rem', src:clear_correct },
        {  width: '27rem', height: '14rem', src:dva},
        {  width: '27rem', height: '14rem', src:hicaps},
        {  width: '27rem', height: '14rem', src:smileLogo ,link: 'https://www.smile.com.au/'},
        {  width: '27rem', height: '14rem', src:medicare},
        { width: '27rem', height: '14rem', src:nsw},
        {  width: '27rem', height: '14rem', src:clear_correct },
        {  width: '27rem', height: '14rem', src:dva},
        {  width: '27rem', height: '14rem', src:hicaps},
    ];


    return (
        <div className="w-full mt-2">
            <div className="overflow-hidden whitespace-nowrap group">
                <div className="inline-block animate-marquee group-hover:animation-paused">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className="inline-block mx-[2rem] text-center"
                            style={{ width: image.width }}
                        >
                            <a  href={image?.link} target="_blank" rel="noopener noreferrer">
                                <div
                                    className="rounded-md overflow-hidden mb-4"
                                    style={{
                                        width: image.width,
                                        height: image.height,
                                    }}
                                >
                                    <img
                                        src={image.src}
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageSlider;
